/* ========================================================================
	jQuery 
======================================================================== */

jQuery.noConflict();
(function( $ ) {

	$(document).ready(function() {

		/* ========================================================================
			Navbar Hamburger
		======================================================================== */

		$('.navbar-toggler').click(function() {
			if( $(this).hasClass('is-active') ) {
				$(this).removeClass('is-active');
			} else {
				$(this).addClass('is-active');
			}
		});


		/* ========================================================================
			Fancybox
		======================================================================== */

		$('.fancybox').fancybox({
			loop: true,
			keyboard: true,
			infobar: false,
			toolbar: true,
			buttons : [
				'close'
			],
			image: {
				preload: "auto"
			},
			touch : {
				vertical: true,
				momentum: true
			}
		});


		/* ========================================================================
			Slick Slider
		======================================================================== */

		// Testimonial slider setup
		$('.testimonial-slider').slick({
			rows: 0,
			dots: true,
			arrows: true,
			infinite: true,
			speed: 600,
			fade: false,
			pauseOnHover: true,
			autoplay: false,
			draggable: true,
			appendDots: $('.testimonial-dots'),
			responsive: [
				{
					breakpoint: 768,
					settings: {
						arrows: false,
					}
				}
			]
		});

		// Logo slider setup
		$('.logo-slider').slick({
	        slidesToShow: 6,
	        slidesToScroll: 1,
	        autoplay: true,
	        autoplaySpeed: 1500,
	        speed: 600,
	        arrows: false,
	        dots: false,
	        pauseOnHover: true,
	        swipeToSlide: true,
	        centerMode: true,
	        responsive: [
		        {
		            breakpoint: 1200,
		            settings: {
		                slidesToShow: 4
		            }
		        }, 
		        {
		            breakpoint: 992,
		            settings: {
		                slidesToShow: 3
		            }
		        },
		        {
		            breakpoint: 768,
		            settings: {
		                slidesToShow: 2
		            }
		        },
	        ]
	    });

	    /* ========================================================================
			Forms
		======================================================================== */

		// Switch layout
		
		$('.switch input[type=checkbox]').change( function() {
			const switchElem = $(this).parent().closest('.switch');
			const slider = $(switchElem).find('.slider');

			if( this.checked ) {
				$(slider).addClass('is-active');
			} else {
				$(slider).removeClass('is-active');
			}
		});


	}); // End document.ready
})(jQuery); // End jQuery